<template>
  <div id="customTable">
    <table width='100%'>
      <colgroup>
        <col v-for="(item, index) in colWidthList" :key="index" :width="item" />
      </colgroup>
      <tr>
        <th class="tableHeader" v-for="(itemStr, index) in thList" :key="index">{{itemStr}}</th>
      </tr>
    </table>
    <div class="rowCls" v-for="(item, index) in dataSource" :key="index">
      <table width='100%'>
        <colgroup>
          <col v-for="(widthItem, widthIndex) in colWidthList" :key="widthIndex" :width="widthItem" />
        </colgroup>
        <tr>
          <td>
            <el-checkbox v-model="item.show" @change="agreeShowAction(item, index)"></el-checkbox>
          </td>
          <td>{{item.phone}}</td>
          <td>{{item.userName}}</td>
          <td>{{item.city}}</td>
          <td>{{item.district}}</td>
          <td>{{item.houseName}}</td>
          <td>
            <span class="btnCls" @click="statusAction(item)">状态</span>
          </td>
          <td>
            <span class="btnCls" @click="equipmentAction(item)">机电</span>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  name: 'customTable',
  data() {
    return {
      thList: [
        '展示',
        '联系电话',
        '客户名称',
        '城市',
        '区域',
        '家庭名称',
        '家庭状态',
        '机电状态'
      ],
      colWidthList: [
        '3%',
        '15%',
        '15%',
        '13%',
        '13%',
        '15%',
        '13%',
        '13%',
      ]
    };
  },
  props: {
    dataSource: null
  },
  methods: {
    statusAction(item) {
      this.$emit('statusBtnAction', [item]);
    },
    equipmentAction(item) {
      this.$emit('equipmentBtnAction', [item]);
    },
    agreeShowAction(item, index) {
      this.$emit('showBtnAction', [item, index]);
    }
  }
}
</script>
<style scoped>
#customTable {
  width: 100%;
}
.tableHeader {
  color: #666666;
  font-size: 14px;
  text-align: center;
  font-weight: normal;
}
.rowCls {
  width: 100%;
  padding: 40px 0px 40px 0px;
  margin-top: 20px;
  border-radius: 10px;
  box-shadow: 0px 8px 18px 0px rgba(206,231,255,0.21);
  font-size: 14px;
  color: #000;
  background-color: #FFFFFF;
}
.rowCls:hover {
  background-color: rgb(241, 241, 241);
}
.btnCls {
  color: #2592FA;
}
.btnCls:hover {
  cursor: pointer;
  text-decoration-line: underline;
}

</style>
<style>
.el-checkbox__inner {
  border-color: #2592FA !important;
}
</style>


// WEBPACK FOOTER //
// src/components/subComponents/customTable/customTable.vue